/**
 * 运行监测组件
 */
import {Style} from '@/libs/style.js';

let template = /*html*/ `<div class="run-monitoring">
    <div class="run-monitoring-header">
        <img src="./images/default/2.png" alt="">
        <h4>运行监测</h4>
    </div>
    <dv-capsule-chart-1 :config="JSON.stringify(config)" style="width:100%;height:200px" />
</div>`;


let style = /* css */ `.run-monitoring{
    position: absolute;
    top: calc(280px + 100px);
    left: 1%;
    width: 25%;
    background: rgba(0,0,0,0.2);
    height: 270px;
    overflow: hidden;
    
}

.run-monitoring .run-monitoring-header{
    background:linear-gradient(to right,#67BDFF,rgba(0,0,0,0) 50%);
    height: 50px;
    color: #fff;
    display:flex;
    align-items:center;
}
.run-monitoring .run-monitoring-header img{
    margin:0 15px;
}
`;

export default (Vue) => {
    Vue.customElement('run-monitoring', {
        template: template,
        data() {
            return {
                config: {
                    data: [
                        {
                          name: 'COD',
                          value: 167
                        },
                        {
                          name: '氨氮',
                          value: 1.2
                        },
                        {
                          name: 'TP',
                          value: 98
                        },
                        {
                          name: 'pH',
                          value: 7.5
                        },
                        {
                          name: 'SS',
                          value: 6
                        },
                      ],
                      colors: ['#e062ae', '#fb7293', '#e690d1', '#32c5e9', '#96bfff'],
                      unit: '单位'
                }
            }
        },
        mounted() {
            Style(style);
        }
    });
}